<template>
  <tr>
    <td :title="item.Logged" style="white-space: nowrap;">{{$root.shortText(item.Logged, 20)}}</td>
    <td style="width: 150px; white-space: nowrap;">{{item.MacAddress}}</td>
    <td :title="item.ModelName" style="white-space: nowrap;">{{$root.shortText(item.ModelName, 20)}}</td>
    <td>{{item.PageCount}}</td>
    <td v-show="activeFilter==='Info' || activeFilter==='All'" :title="item.Status">{{$root.shortText(item.Status, 10)}}</td>
    <td v-show="activeFilter==='Info' || activeFilter==='All'">{{item.IPAddress}}</td>
    <td v-show="activeFilter==='Info' || activeFilter==='All'">{{item.PrinterSerial}}</td>
    <td v-show="activeFilter==='Info' || activeFilter==='All'">{{item.HostName}}</td>
    <td v-show="activeFilter==='Info' || activeFilter==='All'" :title="item.Location" style="white-space: nowrap;">{{$root.shortText(item.Location, 10)}}</td>
    <td v-show="activeFilter==='Info' || activeFilter==='All'" :title="item.ErrorString">{{$root.shortText(item.ErrorString, 20)}}</td>
    <td v-show="activeFilter==='Counters' || activeFilter==='All'">{{item.A4Black}}</td>
    <td v-show="activeFilter==='Counters' || activeFilter==='All'">{{item.A4Color}}</td>
    <td v-show="activeFilter==='Counters' || activeFilter==='All'">{{item.A3Black}}</td>
    <td v-show="activeFilter==='Counters' || activeFilter==='All'">{{item.A3Color}}</td>
    <td v-show="activeFilter==='Counters' || activeFilter==='All'">{{item.Copy}}</td>
    <td v-show="activeFilter==='Counters' || activeFilter==='All'">{{item.Scan}}</td>
    <td v-show="activeFilter==='Counters' || activeFilter==='All'">{{item.Duplex}}</td>
    <td v-show="activeFilter==='Counters' || activeFilter==='All'">{{item.Fax}}</td>
    <td v-show="activeFilter==='Toners' || activeFilter==='All'">
      <div class="progress-group">
        <div class="progress sm" style="background-color: #ccc; height: 20px;">
          <div :class="['progress-bar progressBlack', getPercent(item.BlackTonerLeft)==='0%' ? 'text-black' : '']" :style="{ width: getPercent(item.BlackTonerLeft) }">{{getPercent(item.BlackTonerLeft)}}</div>
        </div>
      </div>
    </td>
    <td v-show="activeFilter==='Toners' || activeFilter==='All'">
      <div class="progress-group">
        <div class="progress sm" style="background-color: #ccc; height: 20px;">
          <div class="progress-bar progressCyan text-black" :style="{ width: getPercent(item.CyanTonerLeft) }">{{getPercent(item.CyanTonerLeft)}}</div>
        </div>
      </div>
    </td>
    <td v-show="activeFilter==='Toners' || activeFilter==='All'">
      <div class="progress-group">
        <div class="progress sm" style="background-color: #ccc; height: 20px;">
          <div class="progressMagenta text-black" :style="{ width: getPercent(item.MagentaTonerLeft) }">{{getPercent(item.MagentaTonerLeft)}}</div>
        </div>
      </div>
    </td>
    <td v-show="activeFilter==='Toners' || activeFilter==='All'">
      <div class="progress-group">
        <div class="progress sm" style="background-color: #ccc; height: 20px;">
          <div class="progress-bar progressYellow text-black" :style="{ width: getPercent(item.YellowTonerLeft) }">{{getPercent(item.YellowTonerLeft)}}</div>
        </div>
      </div>
    </td>
    <td style="text-align: right; width: 80px;">
      <a style="margin-left: 10px; cursor: pointer;" @click="info(item)" title="Info">
        <i class="fa fa-info-circle" style="font-size: 20px; color: #3c8dbc;"></i>
      </a>
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'PrinterItem',
    props: ['item', 'index', 'activeFilter'],
    computed: {
      btnIcon () {
        if (this.widgetType === 'collapse') {
          return this.isOpen ? 'fa fa-minus' : 'fa fa-plus'
        } else if (this.widgetType === 'remove') {
          return 'fa fa-times'
        }
        return ''
      }
    },
    created () {

    },
    methods: {
      getPercent (colorLeft) {
        if (colorLeft && colorLeft.length > 0) {
          if (colorLeft.indexOf('-') >= 0) {
            return '0%'
          }
          colorLeft = colorLeft.replace('%', '')
          colorLeft = colorLeft.split('.')[0]
          return colorLeft + '%'
        } else {
          return '0%'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// PrinterItem.vue?7c95d660